<template>
<b-modal v-model="showFlg"
         size="lg"
         header-bg-variant="light"
         :modal-class="'setHeight081'"
         :title="$t('tk012.labels.title1')"
         :hide-footer="true"
         @hide ="handleCancel"
         no-close-on-backdrop>
    <div class="tk012" v-cloak>
        <div class="pageFeed">
            <div class="section-inner">
                <h3 class="subTitle">{{$t('pt405.labels.title')}}</h3>
                <div v-if="isPagingDisplay">
                    <page-feed
                        :isDisplay="isPagingDisplay"
                        :pageFeedData="pageFeedData"
                        :orderByType="ptOrderByType"
                        :dispPageSizeList="dispPageSizeList"
                        :isDisplaySort="false"
                        @search="changeSearch"
                        >
                        <template slot="TableRender">
                            <div class="memberTdkInfo" v-if="getLengthObj(pt405Init.tdkList) > 0">
                                <!--page table -->
                                <table class="memberTdkTable" id="cart-history">
                                    <thead class="memberTdkColumn">
                                        <!-- No. -->
                                        <th scope="col" class="w80">{{$t('common.labels.no')}}</th>
                                        <!-- 配送先名 -->
                                        <th scope="col" class="w160">{{$t('common.labels.deliName')}}</th>
                                        <!-- お届け先 -->
                                        <th scope="col">{{$t('pt405.labels.tdkAddress')}}</th>
                                    </thead>
                                    <tbody class="memberTdkData">
                                        <tr v-for="(item, index) in pt405Init.tdkList" :key="index">
                                            <!-- No. -->
                                            <td class="cart-num" scope="row" :aria-label="$t('common.labels.no')">{{index+1}}</td>
                                            <!-- 配送先名 -->
                                            <td scope="row" :aria-label="$t('common.labels.deliName')">
                                                {{item.TDK_NM1}}&nbsp;{{item.TDK_NM2}}
                                                <!-- 変更 -->
                                                <span class="btnChange">
                                                    <a class="btnSubmit" @click="doDetail(item)"><font>{{$t('common.buttons.change')}}</font></a>
                                                </span>
                                            </td>
                                            <!-- お届け先 -->
                                            <td scope="row" :aria-label="$t('pt405.labels.tdkAddress')">
                                                {{$t('pt405.labels.zip')}}{{item.TDK_ZIP}}<br>
                                                {{item.KEN_NM}}{{item.TDK_ADDR1}}<br>
                                                {{item.TDK_ADDR2}}<br>
                                                {{item.TDK_ADDR3}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </page-feed> 
                </div>
                <b-btn size="sm" class="btnCancel" variant="secondary" @click="showFlg = false">
                    {{$t('common.buttons.close')}}
                </b-btn>
            </div>
        </div>
    </div>
</b-modal>
</template>

<script>
import axios from "assets/js/request";
import common from 'assets/js/common';
import PageFeed from "../commonParts/PageFeedTdk";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import EventBus from "assets/js/eventBus";

export default {
    name: "tk020",
    components: {
        PageFeed,
        InputNumber,
        EventBus,
        Breadcrumb
    },
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        }
    },
    data: function() {
        return {
            pageID: 'tk020',
            isDisplay: false,
            isPagingDisplay: false,
            pt405ReqModel: {
                sItemNo: null,
                orderType: 0,
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 15,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt405Init: {
                pageNo: null,
                pageSize: null,
                tdkList: {}
            },
            queryData:null,
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },
            dispPageSizeList:[
                {value: 10,text: "10行"},
                {value: 15,text: "15行"},
                {value: 30,text: "30行"},
                {value: 45,text: "45行"},
                {value: 50,text: "50行"},
                {value: 100,text: "100行"}
            ],
            SiteConstants: SiteConstants,
            showFlg: true,
            site: ""
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK012 + _this.$UrlConstants.DO_INIT, _this.pt405ReqModel).then(function(response) {
            if(response.data.isLogin == false){
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
            }else{
                _this.pt405Init = response.data;
                _this.getDataForPageFeed(response.data);
            }
        }).catch(function(error) {
            common.errorAPI(error);
        });
    },
    methods: {
        doDelete: function(tdkNo){
            var _this = this;
            _this.pt405ReqModel.tdkNo = tdkNo;
            _this.$emit("event-loading", true);
            // api
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.TK012 + _this.$UrlConstants.DO_DELETE, _this.pt405ReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.pt405Init = response.data;
                    _this.getDataForPageFeed(response.data);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        /**
         * delete favorite product
         * @param {String} tdkMSeq, tdk product
         */
        doDetail: function(tdkMSeq){
            var _this = this;
            var value = {};
            value.TDK_CD = tdkMSeq.TDK_CD;
            value.TDK_NO = tdkMSeq.TDK_NO;
            value.TDK_NM1 = tdkMSeq.TDK_NM1;
            value.TDK_NM2 = tdkMSeq.TDK_NM2;
            value.TDK_KANA1 = tdkMSeq.TDK_KANA1;
            value.TDK_KANA2 = tdkMSeq.TDK_KANA2;
            value.TDK_ZIP = tdkMSeq.TDK_ZIP;
            value.TDK_ADDR11 = tdkMSeq.TDK_ADDR11;
            value.TDK_ADDR2 = tdkMSeq.TDK_ADDR2;
            value.TDK_ADDR3 = tdkMSeq.TDK_ADDR3;
            value.TDK_TEL1 = tdkMSeq.TDK_TEL1;
            value.TDK_TEL2 = tdkMSeq.TDK_TEL2;
            this.$emit("data-selected", value);
            _this.showFlg = false;
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.pt405ReqModel.pageSize = pageSize;
            this.pt405ReqModel.pageNo = pageNo;
            this.pt405ReqModel.orderType = sortNo;

            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT405 + _this.$UrlConstants.DO_INIT, _this.pt405ReqModel).then(function(response) {
                if(response.data.isLogin == false){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                }else{
                    _this.pt405Init = response.data;
                    _this.getDataForPageFeed(response.data);
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
            
        },
        /**
         * get page size, page no
         * @param {Number} val
         * @param {String} type
         */
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.pt405ReqModel.pageNo;
            query.ptPageSize = this.pt405ReqModel.pageSize;
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /**
         * get data for page feed
         * @param {Object} data, data from API
         */
        getDataForPageFeed: function(data){
            var _this = this;
            _this.pageFeedData.totalRecord = data.totalRecord;
            _this.pageFeedData.fromRecord = data.fromRecord;
            _this.pageFeedData.toRecord = data.toRecord;
            _this.pageFeedData.pageSize = data.pageSize;
            _this.pageFeedData.pageNo = data.pageNo;

            if(_this.pt405Init.tdkList.length > 0){
                _this.isPagingDisplay = true;
            }else{
                _this.isPagingDisplay = false;
            }
        },
        handleCancel(evt){
            evt.preventDefault();
            this.$emit("data-selected", null);
            this.showFlg = false;
        } 
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    }
}
</script>
